import {Directive, Input, forwardRef} from '@angular/core';
import {AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors} from "@angular/forms";
import {delay, Observable, of, switchMap} from "rxjs";
import {map} from "rxjs/operators";
import {UserService} from "../services/user.service";

@Directive({
    selector: '[appEmailExist]',
    providers: [
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: forwardRef(() => EmailExistDirective),
            multi: true
        }
    ],
    standalone: false
})

export class EmailExistDirective implements AsyncValidator {

  @Input() existsError = true;

  constructor(private userService : UserService) {
  }

  validate(control: AbstractControl): Observable<ValidationErrors | null> {
    if (!control.value || !control.dirty) {
      return of(null);
    }

    return of(control.value).pipe(delay(500),
      //Then instead return the observable of us actually checking the value.
      switchMap((email) =>
        this.userService.checkIfUserExists(email).pipe(map(response => {
          switch (response?.message) {
            case 'N' : {
              return !this.existsError ? {exists: false} : null;
            }
            case 'Y' : {
              return this.existsError ? {exists: true} : null;
            }
            default: {
              // invalid pattern
              return {error: response?.message};
            }
          }
        }))
      )
    );
  }
}
